import * as types from "../../actions/actionTypes";

const initialState = {
  warningStatus: false,
  warningMessage: ""
};

const ChangeAccessDenied = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_ACCESS_DENIED_SHOW_WARNING:
      return { ...state, warningStatus: true, warningMessage: action.data };
    case types.CHANGE_ACCESS_DENIED_CLOSE_WARNING:
      return { ...state, warningStatus: false, warningMessage: "" };
    default:
      return state;
  }
};

export default ChangeAccessDenied;
